import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, getGestorOperacoes, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import alterarOrdem from '../../actions/trecho/alterarOrdem';
import buscarTrechos from '../../actions/trecho/buscarTrechos';
import ReactTooltip from 'react-tooltip';

import buscarUltimosHistoricosTrecho from '../../actions/trecho/buscarUltimosHistoricosTrecho';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';

export class Trecho extends React.Component {
  selecionarTrecho (trecho) {    
    this.props.selecionarTrecho(trecho)
    this.props.changeFieldValue('formularioCadastroTrecho',
      'idTrecho', trecho.id);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'cidadeDestino', {
        label: trecho.cidadeDestino.nome,
        value: trecho.cidadeDestino.id
      });
    this.props.changeFieldValue('formularioCadastroTrecho',
      'estadoDestino', {
        label: trecho.cidadeDestino.descricaoUf,
        value: trecho.cidadeDestino.uf
      });
    if (trecho.conexao) {
      this.props.changeFieldValue('formularioCadastroTrecho',
        'conexao', {
          label: `${trecho.conexao.prefixo ? trecho.conexao.prefixo : 'Prefixo não informado'}: ${trecho.conexao.cidadeOrigem.nome}-${trecho.conexao.cidadeOrigem.uf} -> ${trecho.conexao.cidadeDestino.nome}-${trecho.conexao.cidadeDestino.uf} `,
          value: trecho.conexao.id
        });
    }
    if(trecho.configuracaoBilhete) {
      this.props.preencherConfiguracoesBilheteSelecinados(trecho.configuracaoBilhete);
    }
    this.props.changeFieldValue('formularioCadastroTrecho',
      'preco', trecho.preco);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'duracao', trecho.duracao);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'taxaEmbarque', trecho.taxaEmbarque);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'pedagio', trecho.pedagio);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'quilometragem', trecho.quilometragem);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'pontoEmbarque',
      trecho.pontoEmbarqueId
        ? { value: trecho.pontoEmbarqueId, label: trecho.pontoEmbarque }
        : trecho.pontoEmbarque);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'plataformaEmbarque', trecho.plataformaEmbarque);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'ordem', trecho.ordem);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'ultimoTrecho', this.props.ultimoTrecho);

    this.props.changeFieldValue('formularioCadastroTrecho',
      'cidadeOrigem', trecho.cidadeOrigem);

    this.props.changeFieldValue('formularioCadastroTrecho',
      'cidadeOrigemAlternativa', trecho.cidadeOrigemAlternativa);

    this.props.changeFieldValue('formularioCadastroTrecho',
      'habilitadoTrechoAlternativoLimeteEstadual', trecho.habilitadoTrechoAlternativoLimeteEstadual);

    this.props.changeFieldValue('formularioCadastroTrecho',
      'cidadeDestinoAlternativa', trecho.cidadeDestinoAlternativa);

    this.props.changeFieldValue('formularioCadastroTrecho',
      'rota',
      {
        label: `${trecho.rotaDto.cidadeOrigem.nome}-${trecho.rotaDto.cidadeOrigem.uf} ->
       ${trecho.rotaDto.cidadeDestino.nome}-${trecho.rotaDto.cidadeDestino.uf} `,
        value: trecho.rotaDto.id
      });
    this.props.changeFieldValue('formularioCadastroTrecho',
      'latitude', trecho.latitude);
    this.props.changeFieldValue('formularioCadastroTrecho',
      'longitude', trecho.longitude);

    this.props.changeFieldValue('formularioCadastroTrecho', 
      'habilitadoVenderSemConexao', trecho.habilitadoVenderSemConexao);

    this.props.changeFieldValue('formularioCadastroTrecho',
        'nomeInstalacao', trecho.nomeInstalacao);

    this.props.changeFieldValue('formularioCadastroTrecho',
        'codigoInstalacao', trecho.codigoInstalacao);

    this.props.changeFieldValue('formularioCadastroTrecho',
          'habilitadoBpeCidadeAlternativo', trecho.habilitadoBpeCidadeAlternativo);

    if (trecho.conexaoAtivaTrechoDestino && trecho.conexaoAtivaTrechoDestino.length) {      
      this.props.preencherConexoesUsadas(trecho.conexaoAtivaTrechoDestino.map(it => {
        return {
          id: it.conexaoOrigemId,
          trechoOrigemId: it.trechoOrigemId,
          descricao: it.descricaoConexaoOrigem,
          nome: it.conexaoOrigemId
        }
      }));
    }

    if (trecho.cidadesOrigensVendaDireta && trecho.cidadesOrigensVendaDireta.length) {      
      this.props.preencherCidadeOrigemVendaDireta(trecho.cidadesOrigensVendaDireta.map(it => {
        return {
          id: it.cidadeOrigemId,
          trechoOrigemId: it.trechoOrigemId,
          descricao: it.descricaoCidadeOrigem,
          nome: it.cidadeOrigemId
        }
      }))
    }

    if (trecho.habilitadoBpeCidadeAlternativo) {
      if (trecho.codigoCidadeDestinoAlternativo != null) {
        const cidadeDestino = {
          id: trecho.codigoCidadeDestinoAlternativo,
          nome: trecho.nomeCidadeDestinoAlternativo,
          uf: trecho.ufDestinoAlternativo
        };

        this.props.selecionarDestino(cidadeDestino);
      }

      if (trecho.codigoCidadeOrigemAlternativo != null) {
        const cidadeOrigem = {
          id: trecho.codigoCidadeOrigemAlternativo,
          nome: trecho.nomeCidadeOrigemAlternativo,
          uf: trecho.ufOrigemAlternativo
        };

        this.props.selecionarOrigem(cidadeOrigem);
      }

    }

  }

  alterarOrdem (trecho, tipo) {
    this.props.alterarOrdem(trecho.id, this.props.idEmpresa, tipo)
      .then(() => {
        this.props.buscarTrechos(this.props.idEmpresa, trecho.rotaDto.id);
      })
  }

  exibirSetaOrdenacao (trecho, tipo, title) {
    if ((trecho.ordem === this.props.trechos[0].ordem && tipo === 'CIMA')
      || (trecho.ordem === this.props.trechos[this.props.trechos.length - 1].ordem && tipo === 'BAIXO')) {
      return;
    }
    return <Autorizacao
      perfisPermitidos={[PERFIL_ADMIN,
        getAdminEmpresa(this.props.idEmpresa),
        getGestorEmpresa(this.props.idEmpresa),
        getGestorOperacoes(this.props.idEmpresa),
        getOperadorEmpresa(this.props.idEmpresa)]}>
      <a onClick={() => this.alterarOrdem(trecho, tipo)} title={title}>
        {tipo === 'BAIXO' ? <i className="material-icons setas-ordenacao mr-1">
          &#xe5cf;
        </i> : <i className="material-icons setas-ordenacao mr-1">
          &#xe5ce;
        </i>}
      </a>
    </Autorizacao>
  }

  exibirIconesOrdenacao (trecho) {
    return (
      <React.Fragment>
        {this.exibirSetaOrdenacao(trecho, 'CIMA', 'Mover para cima')}
        {trecho.ordem}º
        {this.exibirSetaOrdenacao(trecho, 'BAIXO', 'Mover para baixo')}
      </React.Fragment>
    )
  }

  exibirIconeConexao () {
    if (this.props.trecho && this.props.trecho.conexao) {
      const conexao = this.props.trecho.conexao;
      const descricao = `${conexao.prefixo ? conexao.prefixo : 'Prefixo não informado'}: ${conexao.cidadeOrigem.nome}-${conexao.cidadeOrigem.uf} → ${conexao.cidadeDestino.nome}-${conexao.cidadeDestino.uf}`;
      return (
        <React.Fragment>
          <span data-tip data-for={`conexao-${conexao.id}`}
                style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', padding: '2px 8px', borderRadius: '20px', background: '#fff3e0', border: '1px solid #FF6A00', color: '#FF6A00', fontSize: '11px', fontWeight: '600', cursor: 'default', whiteSpace: 'nowrap' }}>
            <i className="material-icons" style={{ fontSize: '13px' }}>swap_horiz</i>
            Conexão
          </span>
          <ReactTooltip id={`conexao-${conexao.id}`} type="dark" effect="solid">
            <span>{descricao}</span>
          </ReactTooltip>
        </React.Fragment>
      );
    }
  }

  exibirIconeCodigoDeBarras () {
    if (this.props.trecho && this.props.trecho.configuracaoBilhete && this.props.trecho.configuracaoBilhete.length > 0) {
      const configuracaoBilhete = this.props.trecho.configuracaoBilhete[0];
      return (
        <React.Fragment>
          <span data-tip data-for={`configuracao-${configuracaoBilhete.id}`}
                style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', padding: '2px 8px', borderRadius: '20px', background: '#e8f5e9', border: '1px solid #43a047', color: '#2e7d32', fontSize: '11px', fontWeight: '600', cursor: 'default', whiteSpace: 'nowrap' }}>
            <i className="material-icons" style={{ fontSize: '13px' }}>receipt</i>
            {configuracaoBilhete.regra.valor} {configuracaoBilhete.valor ? `R$ ${configuracaoBilhete.valor}` : ''}
          </span>
          <ReactTooltip id={`configuracao-${configuracaoBilhete.id}`} type="dark" effect="solid">
            <span>Regra de Bilhete: {configuracaoBilhete.regra.valor}</span>
          </ReactTooltip>
        </React.Fragment>
      );
    }
  }

  render () {
    return (
      <div className="vx-gp-row">
        <div className="vx-gp-row-main vx-gp-row-main--trecho">
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Ordem</span>
            <span style={{ display: 'flex', alignItems: 'center' }}>{this.exibirIconesOrdenacao(this.props.trecho)}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Cidade Origem</span>
            <span>{this.props.trecho.cidadeOrigem}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Embarque</span>
            <span>{this.props.trecho.pontoEmbarque}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Cidade Destino</span>
            <div>
              <span>{this.props.trecho.cidadeDestino.nomeComUf}{this.props.trecho.cidadeAlternativa ? ` - *${this.props.trecho.cidadeAlternativa}` : ''}</span>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '5px' }}>
                {this.exibirIconeConexao()}
                {this.exibirIconeCodigoDeBarras()}
              </div>
            </div>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Duração</span>
            <span>{this.props.trecho.duracao} h</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">KM</span>
            <span>{this.props.trecho.quilometragem} km</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Taxa Emb.</span>
            <span>R$ {this.props.trecho.taxaEmbarque}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Pedágio</span>
            <span>R$ {this.props.trecho.pedagio}</span>
          </div>
          <div className="vx-gp-field">
            <Autorizacao
              perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.idEmpresa),
                getGestorEmpresa(this.props.idEmpresa),
                getGestorOperacoes(this.props.idEmpresa),
                getOperadorEmpresa(this.props.idEmpresa)]}>
              <div className="dropdown">
                <button className="vx-actions-trigger" type="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i className="material-icons">more_vert</i>
                </button>
                <div className="dropdown-menu vx-gp-dropdown-menu">
                  <a className="vx-gp-dropdown-item" href="#!"
                     data-toggle="modal" data-target="#modalCadastrarTrecho"
                     onClick={() => { this.props.setIsModalOpen(true); this.selecionarTrecho(this.props.trecho); }}>
                    <i className="material-icons">edit</i> Editar
                  </a>
                  <a className="vx-gp-dropdown-item" href="#!"
                     data-toggle="modal" data-target="#modalConfirmacaoExclusaoTrecho"
                     onClick={() => this.props.selecionarTrecho(this.props.trecho)}>
                    <i className="material-icons">delete</i> Excluir
                  </a>
                  <a className="vx-gp-dropdown-item" href="#!"
                     data-toggle="modal" data-target="#modalHistoricoTrecho"
                     onClick={() => {
                       this.selecionarTrecho(this.props.trecho);
                       this.props.buscarUltimosHistoricosTrecho(this.props.trecho.id, this.props.idEmpresa);
                     }}>
                    <i className="material-icons">history</i> Histórico
                  </a>
                </div>
              </div>
            </Autorizacao>
          </div>
        </div>
      </div>
    )
  }
}

export function mapStateToProps () {
  return {}
}

export default connect(mapStateToProps, {
  changeFieldValue,
  alterarOrdem,
  buscarTrechos,
  buscarUltimosHistoricosTrecho,
  selecionarDestino,
  selecionarOrigem
})(reduxForm({
  form: 'formularioCadastroTrecho'
})(Trecho))
